import { ActivatedRoute, Router } from '@angular/router';
import { ProductService } from '../../services/product/product.service';
import { ToastrService } from 'ngx-toastr';
import { PdvService } from '../../services/pdv/pdv.service';
import { OrdersService } from '../../services/order/orders.service';
import { MenuService } from '../../services/menu/menu.service';
import { FamilyService } from '../../services/family/family.service';
import { Component, ViewChild, ElementRef, HostListener, Input } from '@angular/core';
import { Subscription, forkJoin } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PersonalizeProductComponent } from '@app/modules/modals/personalize-product/personalize-product.component';
import { MenuModalComponent } from '@app/modules/modals/menu-modal/menu-modal.component';
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
@Component({
    selector: 'carte',
    templateUrl: 'carte.component.html',
    styleUrls: ['carte.component.scss'],
})
export class CarteComponent {
    @Input()
    header = 0;
    @ViewChild('carte') carte: ElementRef;
    @ViewChild("template") template: ElementRef;
    loadProducts: boolean[] = [];
    loadMenus: boolean[] = [];
    options: any;
    compositions: any[] = [];
    searchElement: String = "";
    families: any[] = [];
    menucategories: any[] = [];
    activeTab = 1;
    products: any[] = [];
    menus: any[] = [];
    familyActive = -2;
    menuCategoryActive = -2;
    idPdv: string;
    orderTypes: any[] = [];
    chosenOrderType: number;
    close: boolean = false;
    bsModalRef: BsModalRef;
    nbrOffersAuthorizedSite: number;
    offerNbr: number;
    menuTime: number;
    subscriptions2: Subscription[] = [];
    selectedComp = [];
    siteClose: boolean = false;
    discount: number = 0;
    discountFrom: number = 0;
    siteCloseComment = "";
    alert = "";
    loading = true;
    idO = -1;
    elementsNbr = 0;
    firstRun = true;
    loadSticky = 0;
    orderProg = null;
    address = null;
    @ViewChild('ordertypebar') ordertypebar: ElementRef
    prevScrollpos = 0;
    orderType;
    constructor(
        private familyService: FamilyService,
        private productService: ProductService,
        private menuService: MenuService,
        private orderService: OrdersService,
        private pdvService: PdvService,
        private modalService: BsModalService,
        private toastr: ToastrService,
        private router: Router,
        private route: ActivatedRoute,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        this.options = {
            multiple: true,
            placeholder: 'Tapez l\'ingrédient désiré...',
            language: 'fr'
        }
    }

    ngOnInit() {
        const subs1 = this.pdvService.pdv.subscribe(
            (data) => {
                this.siteClose = data.closeSite;
                this.siteCloseComment = data.closeComment;
                this.alert = data.alert;
                this.discount = data.discount;
                this.discountFrom = data.discountFrom;
            }
        )
        const subs2 = this.pdvService.orderTypes.subscribe((orderTypes: any[]) => {
            this.orderTypes = orderTypes;
            if (this.orderTypes.length == 0) {
                this.router.navigate(['/'])
            }
        });
        const subs8 = this.orderService.orderType.subscribe((orderType) => {
            this.orderType = orderType;
        });
        const subs3 = this.pdvService.nbrOffersAuthorizedSite.subscribe((nbrOffersAuthorizedSite: number) => {
            this.nbrOffersAuthorizedSite = nbrOffersAuthorizedSite;
        });
        const subs4 = this.orderService.offerNbr.subscribe((offerNbr: any) => {
            this.offerNbr = offerNbr;
        });
        const subs5 = this.orderService.order.subscribe(order => {
            this.elementsNbr = order.elementsNbr;
        });
        const subs6 = this.orderService.orderProg.subscribe((orderProg) => {
            this.orderProg = orderProg;
        });
        const subs7 = this.orderService.chosenOrderType.subscribe((chosenOrderType: number) => {
            this.chosenOrderType = chosenOrderType;
            if (this.chosenOrderType > 0) {
                if (this.chosenOrderType == 1) {
                    const subs10 = this.orderService.address.subscribe((address) => {
                        if (!address) {
                            this.router.navigate(["/modes"]);
                        }
                        this.address = address;
                    });
                    this.subscriptions2.push(subs10);
                }
                this.orderType = this.chosenOrderType;
                this.getCompositionsOfCarte();
            }
            this.getElements();
        });
        this.subscriptions2.push(subs1, subs2, subs3, subs4, subs5, subs6, subs7, subs8);
    }

    getElements() {
        Promise.all([this.getFamiliesOfCarte(), this.getMenuCategoriesOfCarte()]).then(
            () => {
                if (this.router.url.indexOf("menu") > -1 || this.router.url.indexOf("famille") > -1) {
                    if (this.router.url.indexOf("menu") > -1) {
                        this.route.params.subscribe(params => {
                            if (params['menu']) {
                                this.familyActive = -2;
                                if (this.menucategories.length > 3) {
                                    this.activeTab = 2;
                                }
                                let k = this.menucategories.findIndex(f => f.slug == params['menu']);
                                if (k > -1) {
                                    this.menuCategoryActive = k;
                                    this.getMenus(this.menuCategoryActive);
                                }
                            }
                        })
                    }
                    if (this.router.url.indexOf("famille") > -1) {
                        this.route.params.subscribe(params => {
                            if (params['family']) {
                                let k = this.families.findIndex(f => f.slug == params['family']);
                                if (k > -1) {
                                    this.familyActive = k;
                                    this.getProducts(this.familyActive);
                                }
                            }
                        })
                    }
                } else {
                    if (this.menucategories.length == 0) {
                        this.familyActive = 0;
                        this.getProducts(0, false);
                    } else {
                        this.menuCategoryActive = 0;
                        this.getMenus(0);
                    }
                }

            }
        )
    }


    setOrderType() {
        this.route.params.subscribe(params => {
            let send = 0;
            if (this.familyActive > 0) {
                this.router.navigate(["/modes"], { queryParams: { famille: this.families[this.familyActive].slug } });
                send++;
            }
            if (send == 0 && this.menuCategoryActive > 0) {
                this.router.navigate(["/modes"], { queryParams: { menu: this.menucategories[this.menuCategoryActive].slug } });
                send++;
            }
            if (send == 0 && params['menu']) {
                this.router.navigate(["/modes"], { queryParams: { menu: params['menu'] } });
                send++;
            }
            if (send == 0 && params['family']) {
                let querparams = { famille: params['family'] }
                this.router.navigate(["/modes"], { queryParams: querparams });
                send++;
            }
            if (send == 0) {
                this.router.navigate(["/modes"]);
            }
        })
    }

    ngAfterViewInit() {
        this.prevScrollpos = window.pageYOffset;
    }

    @HostListener('window:scroll', ['$event']) onScrollEvent($event) {
        if (isPlatformBrowser(this.platformId)) {
            if (!this.siteClose) {
                let currentScrollPos = window.pageYOffset;
                if (this.prevScrollpos >= currentScrollPos) {
                    this.header = 140;
                    this.ordertypebar.nativeElement.style.display = "block";
                } else {
                    this.header = 75;
                    this.ordertypebar.nativeElement.style.display = "none";
                }
                this.prevScrollpos = currentScrollPos;
            } else {
                this.header = 130;
            }
        }
    }

    PersonalizeModal(i) {
        if (this.chosenOrderType > 0) {
            let product = this.products[i];
            this.bsModalRef = this.modalService.show(PersonalizeProductComponent, { class: 'modal-content3' });
            this.bsModalRef.content.product = product;
        } else {
            this.setOrderType();
        }
    }

    OpenMenuModal(i) {
        if (this.chosenOrderType > 0) {
            if (this.menus[i].offer == null || (this.menus[i].offer != null && this.offerNbr < this.nbrOffersAuthorizedSite)) {
                this.bsModalRef = this.modalService.show(MenuModalComponent, { class: 'modal-content3 menu-modal' });
                this.bsModalRef.content.menu = this.menus[i];
            } else {
                this.toastr.error('', 'Vous avez atteint le nombre d\'offre autorisée');
            }
        } else {
            this.setOrderType();
        }
    }

    getFamiliesOfCarte() {
        return this.familyService.getFamiliesOfCarte().toPromise().then(
            (families: any[]) => {
                this.families = families.sort(
                    (a, b) => {
                        if (a.order === null) {
                            return 1;
                        }
                        else if (b.order === null) {
                            return -1;
                        }
                        if (Number(a.order) > Number(b.order)) {
                            return 1;
                        }
                        if (Number(a.order) < Number(b.order)) {
                            return -1;
                        }
                        return 0;
                    }
                );
            }
        )
    }

    getMenuCategoriesOfCarte() {
        return this.familyService.getMenuCategoriesOfCarte().toPromise().then(
            (menucategories: any[]) => {
                this.menucategories = menucategories.sort(
                    (a, b) => {
                        if (a.order === null) {
                            return 1;
                        }
                        else if (b.order === null) {
                            return -1;
                        }
                        if (a.order > b.order) {
                            return 1;
                        }
                        if (a.order < b.order) {
                            return -1;
                        }
                        return 0;
                    }
                )
            }
        )
    }

    getMenus(i) {
        this.familyActive = -2;
        this.menuCategoryActive = i;
        this.loadMenus = [];
        this.loading = true;
        this.goToTopCart();
        return this.menuService.getMenusOfCategory(this.menucategories[i].id, this.orderType, this.orderProg).toPromise().then(
            (menus: any[]) => {
                this.menus = menus;
                // this.goToTopCart();
                this.loading = false;
                if (this.loadSticky != this.activeTab) {
                    this.loadSticky = this.activeTab
                }
            }
        )
    }

    goToTopCart() {
        if (isPlatformBrowser(this.platformId)) {
            setTimeout(
                () => {
                    let element = document.getElementById('carte');
                    let yourHeight = 150;
                    element.scrollIntoView(true);
                    let scrolledY = window.scrollY;
                    if (scrolledY) {
                        window.scroll(0, scrolledY - yourHeight);
                    }
                }
            ), 500
        }
    }

    getProducts(i, scroll = true) {
        this.familyActive = i;
        this.menuCategoryActive = -2;
        this.loadProducts = [];
        this.loading = true;
        if (scroll) {
            this.goToTopCart();
        }
        return this.productService.getActiveProductByFamily(this.families[i].id, this.orderType, this.orderProg).toPromise().then(
            (data: any[]) => {
                this.products = data;
                this.loading = false;
                if (this.loadSticky != this.activeTab) {
                    this.loadSticky = this.activeTab
                }
            }
        );
    }

    addElementToBasket(i) {
        if (this.chosenOrderType > 0) {
            let product = this.products[i];
            let element = {
                id: product.id,
                code: product.code,
                name: product.name,
                family: product.family,
                size: product.sizes[product.size],
                comment: '',
                qty: 1,
                removedCompositions: [],
                supplements: [],
                optionIngredients: [],
                total: 0,
                vat: product.vat,
                priceSuppApp: product.priceSuppApp,
                priceWithSupp: Number(product.sizes[product.size].price),
                maxNbrIngOptions: product.maxNbrIngOptions,
                hasSupp: product.hasSupp
            }
            element.total += Number(element.size.price);
            element.total *= Number(element.qty);
            this.orderService.addElementToOrder(element);
        } else {
            this.setOrderType();
        }
    }

    changedCompositions() {
        return new Promise((v) => {
            this.products = [];
            if (this.selectedComp.length > 0) {
                this.productService.getElementByCompositions(this.selectedComp, this.orderType, this.orderProg).subscribe(
                    (products: any[]) => {
                        this.products = products;
                        this.familyActive = -1;
                        this.menuCategoryActive = -2;
                        v(1);
                    }
                )
            } else {
                this.products = [];
                v(1);
            }
        })
    }

    searchForElement() {
        return new Promise((v) => {
            if (this.searchElement.length >= 3) {
                this.products = [];
                this.menus = [];
                this.familyActive = -1;
                this.menuCategoryActive = -1;
                forkJoin(
                    [
                        this.productService.getActiveProductBySearch(this.searchElement, this.orderType, this.orderProg),
                        this.menuService.getActiveMenuBySearch(this.searchElement, this.orderType, this.orderProg)
                    ]
                ).subscribe(
                    (data: any[]) => {
                        this.products = data[0];
                        this.menus = data[1];
                        v(1)
                    })
            } else {
                this.products = [];
                this.menus = [];
                v(1)
            }
        })
    }

    getCompositionsOfCarte() {
        this.pdvService.getCompositionsOfCarte().subscribe(
            (compositions: any[]) => {
                this.compositions = compositions;
            }
        )
    }


    unsubscribe2() {
        this.subscriptions2.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions2 = [];
    }

    ngOnDestroy() {
        this.unsubscribe2();
    }

    changeMode(id) {
        if (this.elementsNbr > 0) {
            this.idO = id;
            this.bsModalRef = this.modalService.show(this.template, {
                class: "ordertype-modal"
            });
        } else {
            let queryParams = { ordeType: id };
            this.router.navigate(['modes'], { queryParams: queryParams })
        }
    }

    confirm() {
        this.bsModalRef.hide();
        this.orderService.clearOrder();
        setTimeout(() => {
            this.router.navigate(['/modes']);
        }, 1000)
    }

    decline() {
        this.bsModalRef.hide();
    }

    setActiveTab(activetab) {
        if (this.activeTab != 1 && activetab == 1) this.getProducts(0);
        if (this.activeTab != 2 && activetab == 2) this.getMenus(0);
        this.activeTab = activetab;
    }

}